import type { IPoint } from '@fluentui/react/lib/Utilities';
import type { FolderForestNodeType } from 'owa-favorites-types';
import { action } from 'satcheljs/lib/legacy';
import mailFavoritesStore from '../store/store';

/*
 * Sets state to spawn a context menu attached to a favorite node.
 */
export let showFavoritesContextMenu = action('showFavoriteContextMenu')(function (
    nodeId: string,
    nodeType: FolderForestNodeType,
    anchor: IPoint,
    folderId?: string
): void {
    mailFavoritesStore.mailFavoritesViewState.contextMenuState = {
        nodeId,
        nodeType,
        folderId,
        anchor,
        treeType: 'favorites',
    };
});

/*
 * Sets state to close the context menu attached to a favorite node.
 */
export let hideFavoritesContextMenu = action('hideFavoriteContextMenu')(function (): void {
    mailFavoritesStore.mailFavoritesViewState.contextMenuState = null;
});
